<template>
  <div>
    <el-table
        :data="getTableDatePage()"
        v-loading="loading"
        border
        @sort-change="sortChange"
        @cell-click="tableCellClick"
        @cell-dblclick="tableCellDblclick"
        @row-click="tableRowClick"
        @row-contextmenu="tableRowContextmenu"
        @row-dblclick="tableRowDblclick"
        @header-click="tableHeaderClick"
        @header-contextmenu="tableHeaderContextmenu"
        ref="elTable"
    >
      <el-table-column
          v-if="ifColumnShow(item)"
          v-for="(item,index) in tableCollumn"
          sortable="custom"
          :prop="item.title"
          :label="item.description"
          :width="flexColumnWidth(item.description,item.title)"
          :key="index">
        <template slot="header" slot-scope="scope">
          <ScreenTableHeader
              :key="scope.column.property"
              :ref="`ScreenTable${scope.column.property}`"
              :header-scope="scope"
              condition-type="list"
              :search-list="searchData"
              @screenChange="getTableDatePage()"
          />
        </template>
        <template slot-scope="scope">
          <span :class="cellStyle(scope.row,item.title)">{{ scope.row[item.title] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20,50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>
    <!-- 右键菜单部分 -->
    <ul v-show="isShowRightMenu" :style="{left:menuLeft+'px',top:menuTop+'px'}" class="contextmenu">
      <li @click="printTable">导出为Excel文件</li>
      <li @click="isShowSelect = true">唤醒搜索框</li>
    </ul>
    <el-dialog
        class="search"
        title="搜索"
        v-dialogDrag
        :visible.sync="isShowSelect"
        width="30%"
        :modal="false"
        :lock-scroll="false"
        :close-on-click-modal="false"
        @close="keyword = '',total = tableDataShow.length"
    >
      <div style="display: flex">
        <el-input @change="classIndex = 0" v-model="keyword" placeholder="请输入内容" style="width: 100%"/>
        <el-button type="primary" :disabled="isEmpty(keyword)" @click="toNaxt()">跳转下一个</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import requestDB from "@/utils/requestDB";
import ScreenTableHeader from "../element/ScreenTableHeader"
import * as XLSX from 'xlsx'

export default {
  components: {ScreenTableHeader},
  data() {
    return {
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      tableData: [],
      tableDataShow : [],
      tableCollumn: [],
      currentPage: 1,
      total: 0,
      pageSize: 20,
      loading: false,
      queryParameters: [],
      isShowRightMenu: false,
      menuLeft: 0,
      menuTop: 0,
      isShowSelect: false,
      keyword: "",
      classIndex: 0,
      screenRef: {}
    }
  },
  props: {
    function_id: Number,
    queryParametersInput:Array
  },
  watch: {
    queryParametersInput:{
      handler(newValue, oldValue) {
        this.queryFormSet()
      },
      deep: true
    }
  },
  async mounted() {
    this.queryFormSet()
    document.addEventListener('contextmenu', this.handleContextMenu)
  },
  beforeDestroy() {
    document.removeEventListener('contextmenu', this.handleContextMenu)
  },
  methods: {
    async queryFormSet(){
      let _queryParameters = this.queryParametersInput.map(item=>{
        let value = item.value
        if (item.value && item.value.length > 0 && item.value[0] === '@'){
          switch (item.value) {
            case '@month-firstDay':
              var data = new Date(); //本月
              data.setDate(1);
              data.setHours(0);
              data.setMinutes(0);
              data.setSeconds(0);
              value = data.getTime()
              break;
            case '@nextMonth-firstDay':
              var currentDate = new Date();
              var nextMonthFirstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1, 0, 0, 0, 0);
              var timestamp = nextMonthFirstDay.getTime();
              value = timestamp
              break;
            case '@month-endDay':
              var currentDate = new Date();
              var nextMonthFirstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1, 0, 0, 0, 0);
              var timestamp = nextMonthFirstDay.getTime();
              value = timestamp-1000
              break;
            case '@now':
              value = new Date().getTime()
              break;
            case '@now-1d':
              value = new Date().getTime() - 86400000
              break;
            case '@now-1w':
              value = new Date().getTime() - 604800000
              break;
            case '@now-1m':
              value = new Date().getTime() - 2592000000
              break;
            case '@now-1y':
              value = new Date().getTime() - 31536000000
              break;
            case '@userId':
              value = this.user.id
              break;
          }
        } else {
          switch (item.type){
            case "Integer":
            case "Double":
            case "DateInteger":
              value = Number(item.value)
              break;
          }
        }
        return {...item,value:value}
      })
      this.queryParameters = _queryParameters
      await this.query(_queryParameters)
    },
    isEmpty(obj) {
      return (obj === undefined || obj === null || obj === '' || obj.length === 0)
    },
    async query(queryParameters) {
      let _data = queryParameters.find(item=>this.isEmpty(item.value) && item.mast !== '0')
      if (_data){
        return
      }
      this.loading = true
      requestDB.post("/call/callFunctionById/"+this.function_id,queryParameters).then(res => {
        this.tableCollumn = res.data.columnMetas
        this.tableData = res.data.result
        this.tableDataShow = [...res.data.result]
        this.total = res.data.result.length
      }).then(() =>{
        this.loading = false
      })
    },
    tableCellClick(row, column, cell, event) {
      let _ret = {row:row,column:column,cell:cell,event:`table${this.function_id}_tableCellClick_${column.property}`}
      this.$emit("tableCellClick",_ret)
    },
    tableCellDblclick(row, column, cell, event) {
      let _ret = {row:row,column:column,cell:cell,event:`table${this.function_id}_tableCellDblclick`}
      this.$emit("tableCellDblclick",_ret)
    },
    tableRowClick(row, column, event) {
      let _ret = {row:row,column:column,event:`table${this.function_id}_tableRowClick`}
      this.$emit("tableRowClick",_ret)
    },
    // 右键弹窗打印
    tableRowContextmenu(row, column, event){
      let _ret = {row:row,column:column,event:`table${this.function_id}_tableRowContextmenu`}
      this.$emit("tableRowContextmenu",_ret)
    },
    tableRowDblclick(row, column, event) {
      let _ret = {row:row,column:column,event:`table${this.function_id}_tableRowDblclick`}
      this.$emit("tableRowDblclick",_ret)
    },
    tableHeaderClick(column, event) {
      let _ret = {column:column,event:event,type:`table${this.function_id}_tableHeaderClick`,table:this.function_id}
      this.$emit("tableHeaderClick",_ret)
    },
    // 右键弹窗打印
    tableHeaderContextmenu(column, event) {
      let _ret = {column:column,event:event,type:`table${this.function_id}_tableHeaderContextmenu`,table:this.function_id}
      this.$emit("tableHeaderContextmenu",_ret)
    },
    getTableDataShow() {
      if (!this.tableDataShow) {
        return []
        this.total = 0
      }
      const _tableDataShow = this.screenData(this.tableDataShow)
      if (this.isEmpty(this.keyword)){
        this.total = _tableDataShow.length
        return _tableDataShow
      } else {
        let _data = _tableDataShow.filter(item=>{
          let _isShow = false
          this.tableCollumn.forEach(column=>{
            if (item && item[column.title] && item[column.title].toString().indexOf(this.keyword) !== -1){
              _isShow = true
            }
          })
          return _isShow
        })
        this.total = _data.length
        return _data
      }
    },
    getTableDatePage() {
      let start = (this.currentPage - 1) * this.pageSize
      let end = start + this.pageSize
      let _tableDataShow = this.getTableDataShow()
      return _tableDataShow.slice(start, end)
    },
    showRightMenu(event) {
      this.isShowRightMenu = true;
      this.menuLeft = event.clientX;
      this.menuTop = event.clientY;
      event.preventDefault();
      // 添加全局事件监听器
      document.addEventListener('click', this.hideRightMenu);
      document.addEventListener('wheel', this.hideRightMenu);
    },
    hideRightMenu() {
      this.isShowRightMenu = false;
      // 移除全局事件监听器
      document.removeEventListener('click', this.hideRightMenu);
      document.removeEventListener('wheel', this.hideRightMenu);
    },
    // 弹窗打印
    printTable() {
      this.hideRightMenu();
      // const modifiedData = this.tableData.map((item) => {
      const modifiedData = this.getTableDataShow().map((item) => {
        let newItem = {}
        for (let key in this.tableCollumn) {
          newItem[this.tableCollumn[key].description] = item[this.tableCollumn[key].title]
        }
        return newItem
      })
      const worksheet = XLSX.utils.json_to_sheet(modifiedData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      this.saveAsExcelFile(excelBuffer, "新建导出文件")
    },
    //保存下载文件
    saveAsExcelFile(buffer, fileName){
      const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(data)
      link.download = fileName + '.xlsx'
      link.click()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableDatePage()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableDatePage()
    },
    // 处理右键点击事件
    handleContextMenu(event) {
      if (this.isClickInsideTable(event)) {
        this.showRightMenu(event);
      } else {
        this.hideRightMenu();
      }
    },
    // 判断点击是否在 el-table 内部
    isClickInsideTable(event) {
      let elTable = this.$refs.elTable.$el;
      let target = event.target;
      while (target) {
        if (target === elTable) {
          return true;
        }
        target = target.parentNode;
      }
      return false;
    },
    //排序
    sortChange({ column, prop, order}){
      if (!order){
        this.tableDataShow = [...this.tableData]
        return
      }
      //根据列名对tableDataShow排序
      this.tableDataShow.sort((a, b) => {
        //如果a,b能转为数字，则转为数字排序
        let _a = a[prop]
        let _b = b[prop]
        if (!isNaN(_a) && !isNaN(_b)) {
          _a = Number(_a)
          _b = Number(_b)
        }
        if (_a === _b) {
          return 0;
        }
        if (order === 'ascending') {
          return _a > _b ? 1 : -1;
        } else {
          return _a < _b ? 1 : -1;
        }
      });
    },
    /**
     * 遍历列的所有内容，获取最宽一列的宽度
     * @param arr
     */
    getMaxLength (arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          const calcLen = this.getTextWidth(item)
          if (acc < calcLen) {
            acc = calcLen
          }
        }
        return acc
      }, 0)
    },
    /**
     * 使用span标签包裹内容，然后计算span的宽度 width： px
     * @param valArr
     */
    getTextWidth (str) {
      let width = 0
      const html = document.createElement('span')
      html.innerText = str
      html.className = 'getTextWidth'
      document.querySelector('body').appendChild(html)
      width = document.querySelector('.getTextWidth').offsetWidth
      document.querySelector('.getTextWidth').remove()
      return width
    },
    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidth (label, prop) {
      // 1.获取该列的所有数据
      const arr = this.getTableDatePage().map(x => x[prop])
      arr.push(label+"$$") // 把每列的表头也加进去算
      // 2.计算每列内容最大的宽度 + 表格的内间距（依据实际情况而定）
      return (this.getMaxLength(arr) + 25) + 'px'
    },
    ifColumnShow(item){
      //判断item.title中是否包含中文字符
      if (item.title !== item.description || item.title.startsWith('$') || /[\u4e00-\u9fa5]/.test(item.title)) {
        return true
      }
    },
    cellStyle(row, column){
      if (!this.isEmpty(this.keyword)){
        if (row && row[column] && row[column].toString().indexOf(this.keyword) !== -1){
          return 'keyword'
        }
      }
      return ''
    },
    toNaxt(){
      //查找所有class为keyword的元素，跳转到该元素
      this.$nextTick(() => {
        let keyword = document.getElementsByClassName('keyword')
        this.classIndex++
        if (keyword.length > 0){
          if (this.classIndex >= keyword.length){
            this.classIndex = 0
          }
          keyword[this.classIndex].scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
        }
      })
    },

    searchData(){
      return this.tableDataShow
    },
    screenData (data){
      //遍历screenRef
      for (const colum of this.tableCollumn) {
        let key = colum.title
        let _screen = this.$refs[`ScreenTable${key}`]
        if (_screen && _screen[0] && _screen[0].dateScreen) {
          try{
            // ref调用子组建方法
            data = _screen[0].dateScreen(data)
          } catch (e) {
            console.error(e)
          }
        }
      }
      return data
    },
  }
}
</script>

<style scoped>
.keyword {
  background-color: #ffc400;
}
.keywordThis {
  background-color: #ff9100;
}
.contextmenu {
  justify-content: space-around;
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}
.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}
.contextmenu li:hover {
  background: #eee;
}

/** 修改el-card默认paddingL:20px-内边距 **/
.el-card__header {
   padding: 10px;
 }
.el-card__body {
   padding: 10px;
 }
/*覆盖层元素增加可穿透点击事件*/
.el-dialog__wrapper {
  pointer-events:none;
}
/*弹窗层元素不可穿透点击事件（不影响弹窗层元素的点击事件）*/
.search /deep/ .el-dialog{
  pointer-events:auto;
}
.search /deep/ .el-dialog__header{
  padding: 1vh 1vw 0 1vw;
}
.search /deep/ .el-dialog__title {
  line-height: 24px;
  font-size: 12px;
  color: #303133;
}
.search /deep/ .el-dialog__headerbtn {
  position: absolute;
  top: 10px;
  right: 15px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 15px;
}
.search /deep/.el-dialog__body{
  padding: 1vh 1vw;
}
